import{resizeObservers as r}from"../utils/resizeObservers.js";var e=function(){return r.some((function(r){return r.activeTargets.length>0}))};export{e as hasActiveObservations};
//# sourceMappingURL=hasActiveObservations.js.map
